import { render, staticRenderFns } from "./OrderListItem.vue?vue&type=template&id=3bbcdff0&lang=pug&"
import script from "./OrderListItem.vue?vue&type=script&lang=js&"
export * from "./OrderListItem.vue?vue&type=script&lang=js&"
import style0 from "./OrderListItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
